import { combineEpics } from 'redux-observable';
import builds from './builds/epics';
import { pollTasksEpic, fetchAllProjects } from './projects/epics';
import releaseGroups from './project_grouping/epics';

const rootEpic = combineEpics(
  builds,
  pollTasksEpic,
  fetchAllProjects,
  releaseGroups,
);

export default rootEpic;
